import * as React from 'react';

const Reconhecimento = () => {
    return(
        <div id="reconhecimento" className="container-fluid col-sm-12 text-center">
            <p className="extra-large-text bold s-margin text-center roxo-e">RECONHECIMENTO</p>
            <div className="container col-sm-6 col-md-8">
                <h3>Selecionados nos melhores programas de aceleração de inovação, saúde e impacto social</h3>
            </div>
            <div className="container col-sm-3 col-md-12 portfolio-s-block-child align-items-center d-flex">
                <div className="col-sm-12 col-md-3"> <img className="img-parceiro" src={require('../css/img/artemisia.png')} alt="we"/> </div>
                <div className="col-sm-12 col-md-3"> <img className="img-parceiro" src={require('../css/img/accenture.png')} alt="we"/> </div>
                <div className="col-sm-12 col-md-3"> <img className="img-parceiro" src={require('../css/img/brazil-lab.png')} alt="we"/> </div>
                <div className="col-sm-12 col-md-3"> <img className="img-parceiro" src={require('../css/img/cientec.png')} alt="we"/> </div>
                <div className="col-sm-12 col-md-3"> <img className="img-parceiro" src={require('../css/img/auspin.png')} alt="we"/> </div>
                <div className="col-sm-12 col-md-3"> <img className="img-parceiro" src={require('../css/img/100-open.png')} alt="we"/> </div>
                <div className="col-sm-12 col-md-3"> <img className="img-parceiro" src={require('../css/img/abqv.png')} alt="we"/> </div>
            </div>
        </div>
    );
}

export default Reconhecimento;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ReconhecimentoComponent.tsx